import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  IconButton,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Dialog,
  DialogContent,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
export default function MasterDynamicTemplateSettings({
  open,
  onClose,
  setDynamicForm,
  editingRow,
}) {
  const [formData, setFormData] = useState({});
  const [allies, setAllies] = useState("");
  const [borderSameToAll, setBorderSameToAll] = useState(false);
  const [paddingSameToAll, setPaddingSameToAll] = useState(false);

  // Helper for border/padding
  const handleBorderPaddingChange = (type, side, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [side]: value,
      },
    }));
  };

  const handleAddAllies = () => {
    if (allies) {
      setFormData((prev) => ({
        ...prev,
        allies: prev.allies ? prev.allies + ", " + allies : allies,
      }));
      setAllies("");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const parsedValue =
      type === "checkbox" ? checked : type === "number" ? Number(value) : value;

    setFormData((preValue) => ({
      ...preValue,
      [name]: parsedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setDynamicForm((prevValue) =>
      prevValue.map((item, index) =>
        index === editingRow?.mainIndex ? formData : item
      )
    );

    onClose();
  };

  useEffect(() => {
    setFormData(editingRow?.rowData || {});
    setBorderSameToAll(false);
    setPaddingSameToAll(false);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "1200px",
            width: "90vw",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent
          sx={{
          maxWidth: "unset",
          width: "97%",
          overflowX: "hidden",
          overflowY: "auto",
          maxHeight: "80vh",
          pb: 0,
          pr: 3,
          "& .MuiFormLabel-asterisk": {
            color: "error.main",
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" fontWeight={700} sx={{ flex: 1 }}>
            Setting
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <form id="dynamic-template-settings-form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                label="Display Text"
                name="displayText"
                value={formData?.displayText || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
                InputProps={{
                  endAdornment: (
                    <IconButton size="small" tabIndex={-1}>
                      <span role="img" aria-label="edit">✎</span>
                    </IconButton>
                  ),
                }}
              />
              <FormControl fullWidth sx={{ bgcolor: "white", mb: 2 }}>
                <InputLabel>Method</InputLabel>
                <Select
                  label="Method"
                  name="method"
                  value={formData?.method || ""}
                  onChange={handleChange}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="Method1">Method1</MenuItem>
                  <MenuItem value="Method2">Method2</MenuItem>
                </Select>
              </FormControl>
              {/* Border */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2">Border</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={borderSameToAll}
                      onChange={(_, checked) => {
                        setBorderSameToAll(checked);
                        if (checked) {
                          const val = formData?.border?.all || "";
                          setFormData((prev) => ({
                            ...prev,
                            border: {
                              all: val,
                              top: val,
                              right: val,
                              bottom: val,
                              left: val,
                            },
                          }));
                        }
                      }}
                    />
                  }
                  label="Same to all"
                />
                {borderSameToAll ? (
                  <TextField
                    label="All"
                    value={formData?.border?.all || ""}
                    onChange={(e) => {
                      handleBorderPaddingChange("border", "all", e.target.value);
                      handleBorderPaddingChange("border", "top", e.target.value);
                      handleBorderPaddingChange("border", "right", e.target.value);
                      handleBorderPaddingChange("border", "bottom", e.target.value);
                      handleBorderPaddingChange("border", "left", e.target.value);
                    }}
                    fullWidth
                    sx={{ bgcolor: "white", mt: 1 }}
                  />
                ) : (
                  <Grid container spacing={1} sx={{ mt: 1 }}>
                    {["top", "right", "bottom", "left"].map((side) => (
                      <Grid item xs={6} key={side}>
              <TextField
                          label={side.charAt(0).toUpperCase() + side.slice(1)}
                          value={formData?.border?.[side] || ""}
                          onChange={(e) => handleBorderPaddingChange("border", side, e.target.value)}
                fullWidth
                sx={{ bgcolor: "white" }}
                          InputProps={{ endAdornment: <span>PX</span> }}
              />
            </Grid>
                    ))}
                  </Grid>
                )}
              </Box>
              {/* Padding */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2">Padding</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={paddingSameToAll}
                      onChange={(_, checked) => {
                        setPaddingSameToAll(checked);
                        if (checked) {
                          const val = formData?.padding?.all || "";
                          setFormData((prev) => ({
                            ...prev,
                            padding: {
                              all: val,
                              top: val,
                              right: val,
                              bottom: val,
                              left: val,
                            },
                          }));
                        }
                      }}
                    />
                  }
                  label="Same to all"
                />
                {paddingSameToAll ? (
                  <TextField
                    label="All"
                    value={formData?.padding?.all || ""}
                    onChange={(e) => {
                      handleBorderPaddingChange("padding", "all", e.target.value);
                      handleBorderPaddingChange("padding", "top", e.target.value);
                      handleBorderPaddingChange("padding", "right", e.target.value);
                      handleBorderPaddingChange("padding", "bottom", e.target.value);
                      handleBorderPaddingChange("padding", "left", e.target.value);
                    }}
                    fullWidth
                    sx={{ bgcolor: "white", mt: 1 }}
                  />
                ) : (
                  <Grid container spacing={1} sx={{ mt: 1 }}>
                    {["top", "right", "bottom", "left"].map((side) => (
                      <Grid item xs={6} key={side}>
              <TextField
                          label={side.charAt(0).toUpperCase() + side.slice(1)}
                          value={formData?.padding?.[side] || ""}
                          onChange={(e) => handleBorderPaddingChange("padding", side, e.target.value)}
                fullWidth
                sx={{ bgcolor: "white" }}
                          InputProps={{ endAdornment: <span>PX</span> }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Box>
              <FormControlLabel
                control={
                  <Checkbox
                    name="bold"
                    checked={formData?.bold || false}
                    onChange={handleChange}
                  />
                }
                label="Bold"
                sx={{ mb: 2 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="elementViewInNewLine"
                    checked={formData?.elementViewInNewLine || false}
                    onChange={handleChange}
                  />
                }
                label="Element View In New Line"
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <RadioGroup
                row
                value={formData?.nameFirst ? "nameFirst" : "valueFirst"}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: "nameFirst",
                      value: e.target.value === "nameFirst",
                    },
                  });
                  handleChange({
                    target: {
                      name: "valueFirst",
                      value: e.target.value === "valueFirst",
                    },
                  });
                }}
                aria-labelledby="orderPreference-label"
                sx={{ mb: 2 }}
              >
                <FormControlLabel
                  label="Name First"
                  value="nameFirst"
                  control={<Radio />}
                />
                <FormControlLabel
                  label="Value First"
                  value="valueFirst"
                  control={<Radio />}
                />
              </RadioGroup>
              <TextField
                label="Width"
                name="width"
                value={formData?.width || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
                InputProps={{ endAdornment: <span>PX</span> }}
              />
              <TextField
                label="Top"
                name="top"
                value={formData?.top || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
                InputProps={{ endAdornment: <span>PX</span> }}
              />
              <TextField
                label="Right"
                name="right"
                value={formData?.right || ""}
                    onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
                InputProps={{ endAdornment: <span>PX</span> }}
              />
              <TextField
                label="Bottom"
                name="bottom"
                value={formData?.bottom || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
                InputProps={{ endAdornment: <span>PX</span> }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="subForm"
                    checked={formData?.subForm || false}
                    onChange={handleChange}
                  />
                }
                label="Has sub form ?"
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Element Name"
                name="elementName"
                value={formData?.elementName || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
              />
              <TextField
                label="Code"
                name="code"
                value={formData?.code || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
              />
              <TextField
                label="Font Size"
                name="fontSize"
                value={formData?.fontSize || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
                InputProps={{ endAdornment: <span>PX</span> }}
              />
              <FormControl fullWidth sx={{ bgcolor: "white", mb: 2 }}>
                <InputLabel>Display Type</InputLabel>
                <Select
                  label="Display Type"
                  name="displayType"
                  value={formData?.displayType || ""}
                  onChange={handleChange}
                >
                  <MenuItem value="Vertical">Vertical</MenuItem>
                  <MenuItem value="Horizontal">Horizontal</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Separator"
                name="separator"
                value={formData?.separator || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white", mb: 2 }}
              />
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2">Allies</Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                    label="Add Allies"
                    value={allies}
                    onChange={(e) => setAllies(e.target.value)}
                fullWidth
                    sx={{ bgcolor: "white", mr: 1 }}
                  />
                  <Button
                    variant="outlined"
                    onClick={handleAddAllies}
                    sx={{ minWidth: 0, px: 2 }}
                  >
                    +
                  </Button>
                </Box>
                <Typography variant="caption" color="textSecondary">
                  {formData?.allies}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
          <Box
            sx={{
              display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          p: 2,
          pt: 0,
          gap: 2,
        }}
      >
        <Button onClick={onClose} color="inherit" variant="outlined">
          Cancel
        </Button>
        <Button type="submit" variant="contained" form="dynamic-template-settings-form">
          Submit
            </Button>
          </Box>
    </Dialog>
  );
}
